module.exports = __webpack_public_path__ + "static/media/arduinoLogo.4e9beaa6.png";